import { useMenu } from "@app/vue/providers/Menu";
import { defineComponent } from "vue";

import { ShopHeaderMain } from "./ShopHeaderMain";
import { ShopHeaderTop } from "./ShopHeaderTop";

export const ShopHeader = defineComponent({
  name: "MenuNavbar",
  setup() {
    const { groupOrder } = useMenu();

    return () => (
      <>
        <ShopHeaderTop />
        {groupOrder.value?.status === "active" ? <ShopHeaderMain /> : null}
      </>
    );
  },
});
